import { render, staticRenderFns } from "./help_content.vue?vue&type=template&id=1f2d5302&scoped=true&"
import script from "./help_content.vue?vue&type=script&lang=js&"
export * from "./help_content.vue?vue&type=script&lang=js&"
import style0 from "./help_content.vue?vue&type=style&index=0&id=1f2d5302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d5302",
  null
  
)

export default component.exports